import logo from './logo.svg';
import './App.css';
import Claims from './Claims';

function App() {
  return (
    <div className="App">
      
 <Claims/>
      
   
    </div>

  );
}

export default App;
